<template>
  <div>
      <section class="services pt-5" id="services">
            <div class="container py-lg-5">
                <p class="paragraph">O que quer que eu faça para você?</p>
                <h3 class="heading mb-sm-5 mb-4">Meus serviços</h3>
                <div class="row">
                    <div class="col-lg-3 col-sm-6 mb-5">
                    <div class="panel panel-default">
                        <div class="panel-thumbnail">
                            <img src="../../static/images/s1.png" alt="" class="img-fluid" />
                            <h3>01</h3>
                            <h4 class="mt-3">Web Design</h4>
                            <p class="mt-3">The greatest style needed ever in a website, blog, etc. I offer it with security. </p>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 mb-5">
                    <div class="panel panel-default">
                        <div class="panel-thumbnail">
                            <img src="../../static/images/s2.png" alt="" class="img-fluid" />
                            <h3>02</h3>
                            <h4 class="mt-3">Mobile Aplication</h4>
                            <p class="mt-3">Aplication for Cross Plataforms, >> Android, IOS, WIndows. </p>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 mb-5">
                    <div class="panel panel-default">
                        <div class="panel-thumbnail">
                            <img src="../../static/images/s3.png" alt="" class="img-fluid" />
                            <h3>03</h3>
                            <h4 class="mt-3">Web Aplicatiion</h4>
                            <p class="mt-3">Web Aplications like Blogs, Sites, and more </p>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 mb-5">
                        <div class="panel panel-default">
                        <div class="panel-thumbnail">
                            <img src="../../static/images/s4.png" alt="" class="img-fluid" />
                            <h3>04</h3>
                            <h4 class="mt-3"> Desktop Aplication</h4>
                            <p class="mt-3">I develop aplications for many purposes depending on client, for Windows Plataforms.</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'Services',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Services.vue